import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'std-checkbox',
    templateUrl: './checkbox.component.html',
    styles: [
        `
      .shadow {
        box-shadow: 2px 4px 12px 0px #0000000d;

        box-shadow: 2px 4px 6px 0px #0000000d inset;
      }
    `,
    ],
    standalone: false
})
export class CheckboxComponent {
  @Input() label: string = 'Checkbox Label';
  @Input() disabled: boolean = false;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() type: 'square' | 'circle' = 'square';
  @Input() borderTrue: string = '#47AD9F';
  @Input() backGroundTrue: string = '#47AD9F';
  @Input() borderFalse: string = '#6B7280';
  @Input() backGroundFalse: string = '#FFFFFF';
  @Input() backGroundDisabled: string = '#BEC5C5';
  @Input() borderDisabled = '#BEC5C5';
  @Input() isChecked: boolean = false;
  @Input() width: string = '';
  @Input() height: string = '';
  @Input() borderRadius: string = '';

  @Output() onChange: EventEmitter<{ checked: boolean; event: Event }> =
    new EventEmitter<{ checked: boolean; event: Event }>();

  onChangeCheck(event: any) {
    event.stopPropagation();
    if (!this.disabled) {
      this.isChecked = !this.isChecked;
      this.onChange.emit({
        checked: this.isChecked,
        event: event.target.value,
      });
    }
  }
}
